import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../../modules/notifier/services/actions';
import {ProfileDto} from '../../../dto/ProfileDto';

export const getProfile = createAsyncThunk<ProfileDto, number>(
    'profile/getProfile',
    async (profileId, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `profiles/${profileId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
